/**
 * Every src/locales/<lang>/<namespace>.json file is picked up automatically.
 * Adding a namespace = adding the JSON file in every language (the i18n test
 * enforces parity). No manual registration.
 */
const modules = import.meta.glob('../../locales/*/*.json', { eager: true, import: 'default' }) as Record<
  string,
  Record<string, unknown>
>;

export const resources: Record<string, Record<string, Record<string, unknown>>> = {};
const nsSet = new Set<string>();
for (const [path, data] of Object.entries(modules)) {
  const m = path.match(/locales\/([^/]+)\/([^/]+)\.json$/);
  if (!m) continue;
  const [, lang, ns] = m;
  (resources[lang] ??= {})[ns] = data;
  nsSet.add(ns);
}

export const NAMESPACES = [...nsSet].sort();
